const BASE_URL = process.env.REACT_APP_API_URL || '';
export const TOKEN_KEY = 'lastdating_token';

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const sleep = (ms) => new Promise(r => setTimeout(r, ms));
const MAX_RETRIES = 6;
const RETRY_INTERVAL = 5000;

const setWaking = (active) =>
  window.dispatchEvent(new CustomEvent('server-waking', { detail: { active } }));

const request = async (method, path, body = null) => {
  const headers = { 'Content-Type': 'application/json' };
  const token = getToken();
  if (token) headers['Authorization'] = `Bearer ${token}`;
  const opts = { method, headers };
  if (body) opts.body = JSON.stringify(body);
  const url = `${BASE_URL}${path}`;

  for (let attempt = 0; attempt <= MAX_RETRIES; attempt++) {
    let res;
    try {
      res = await fetch(url, opts);
    } catch {
      // Network error — server unreachable (common during Render cold start)
      if (attempt < MAX_RETRIES) {
        if (attempt === 0) setWaking(true);
        await sleep(RETRY_INTERVAL);
        continue;
      }
      setWaking(false);
      throw new Error('Just a moment — still warming up. Please try again.');
    }

    const contentType = res.headers.get('content-type') || '';

    if (res.status === 401 || res.status === 403) {
      if (attempt > 0) setWaking(false);
      throw new Error('session_expired');
    }

    if (!contentType.includes('application/json')) {
      // Render sleep page returns HTML — retry until warm
      if (attempt < MAX_RETRIES) {
        if (attempt === 0) setWaking(true);
        await sleep(RETRY_INTERVAL);
        continue;
      }
      setWaking(false);
      throw new Error('Just a moment — still warming up. Please try again.');
    }

    if (attempt > 0) setWaking(false);
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'Request failed');
    return data;
  }
};

export const api = {
  post: (path, body) => request('POST', path, body),
  get: (path) => request('GET', path),
  delete: (path) => request('DELETE', path),
  patch: (path, body) => request('PATCH', path, body),
};
